import { mapActions } from 'vuex'
import SignInMixin from '@/store/module/signIn/mixin'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'Authentication',
  data () {
    return {
      theme: process.env.Theme,
      version: process.env.VersionApp
    }
  },
  mixins: [
    SignInMixin
  ],
  computed: {
    IsThemeSDS: function () {
      var result = false
      if (this.theme === 'SDS') {
        result = true
      }
      return result
    },
    IsThemeCOTEXO: function () {
      var result = false
      if (this.theme === 'COTEXO') {
        result = true
      }
      return result
    },
    IsThemeCONSTAR: function () {
      var result = false
      if (this.theme === 'CONSTAR') {
        result = true
      }
      return result
    },
    classBgImg: function () {
      var result = 'bg-img-acelerauto'
      if (this.theme === 'SDS') {
        result = 'bg-img'
      } else if (this.theme === 'COTEXO') {
        result = 'bg-img-cotexo'
      } else if (this.theme === 'CONSTAR') {
        result = 'bg-img-constar'
      }
      return result
    }
  },
  methods: {
    ...mapActions({
      signIn: authActions.SIGN_IN
    }),
    validateAndSignIn () {
      this.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.signIn(this.credentials)
              .then((success) => {
                if (success) {
                  this.$router.push({ name: 'StartPage' })
                }
              })
              .catch((e) => {
                if (e.message === 'Not authorized') {
                  toast.error(this.$lang.Login.InvalidCredentials)
                } else {
                  toast.error(this.$lang.Login.ServiceOff)
                }
              })
          }
        })
    },
    getValidationState (fieldName) {
      const field = this.$validator.fields.find({ name: fieldName })

      if (!field) return null

      const isDirty = field.flags.dirty
      const isValid = !this.errors.has(fieldName)
      return isDirty ? isValid : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/auth/Authentication.js